<template>
    <div class="index">
        <div class="index-menu">
            <div class="menu-content">
                <div class="content-logo">
                    <img class="logo" src="@/static/img/logo.png">
                </div>
                <div class="content-data">
                    <template v-for="(item, key) in menuItem">
                        <span :class="activeMenu == item ? 'data-active' : 'data-item'" @click="handleMenu(item, key)">{{ item }}</span>
                    </template>
                </div>
            </div>
        </div>
        <div class="index-body">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="body-home">
                            <div :class="activeMenu == '网站首页' ? 'home-content fadeinLAnimation' : 'home-content'">
                                为用户提供<br>多样化的<span>智能</span>生活
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="body-about">
                            <div class="about-content">
                                <div :class="activeMenu == '关于我们' ? 'about-title fadeinTAnimation' : 'about-title'"></div>
                                <div :class="activeMenu == '关于我们' ? 'about-data fadeinLAnimation' : 'about-data'">
                                    <div :class="activeMenu == '关于我们' ? 'about-item fadeinLAnimation' : 'about-item'">
                                        <div :class="activeMenu == '关于我们' ? 'about-item-title fadeinLAnimation' : 'about-item-title'">中润天骐</div>
                                        <div :class="activeMenu == '关于我们' ? 'about-item-content fadeinLAnimation' : 'about-item-content'">
                                            黑龙江中润天骐科技发展有限公司成立于2016年10月，是全国首批从事智慧医疗、智慧养老、智慧社区建设艾米奈华智能科技有限公司的全资子公司，是艾米奈华的智慧城市建设主平台。先后通过了国家高新技术企业认证、ISO9001认证、省级示范企业等系列荣誉和资质，公司致力于以城市为核心，基于大数据、大健康的医养生态圈建设，以社区及社区居民作为主依托，以慢性病预防、养老养生、精准医疗、利民服务、便民政务五大模块的互联互通为愿景，利用互联网、智能设备、商业模式手段，首次提出了“1+1+5”模式，即社区+互联网+“预、养、医、服、政”的即时性本地化的城市深度医养结合生态体系。先后为全国众多省级、地市级、县（区）级民政系统、卫生系统、医疗机构、养老机构的顶层信息化建设提供解决方案和具体落地实施，在B2B2C模式下具有丰富的落地实施经验。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="body-six">
                            <div :class="activeMenu == '六大优势' ? 'six-title fadeinTAnimation' : 'six-title'"></div>
                            <div :class="activeMenu == '六大优势' ? 'six-data flipinYAnimation' : 'six-data'">
                                <div class="six-list">
                                    <div class="sixe-list-img">
                                        <img src="@/static/img/siximg1.png">
                                    </div>
                                    <div class="sixe-list-title">
                                        慢性病干预
                                    </div>
                                    <div class="sixe-list-content">
                                        精准管理用户慢性病和亚健康问题，满足用户对健康和医疗资源的需求
                                    </div>
                                </div>
                                <div class="six-list">
                                    <div class="sixe-list-img">
                                        <img src="@/static/img/siximg2.png">
                                    </div>
                                    <div class="sixe-list-title">
                                        互联网+
                                    </div>
                                    <div class="sixe-list-content">
                                        建立医院远程无线健康云监护平台
                                    </div>
                                </div>
                                <div class="six-list">
                                    <div class="sixe-list-img">
                                        <img src="@/static/img/siximg3.png">
                                    </div>
                                    <div class="sixe-list-title">
                                        全程跟踪干预
                                    </div>
                                    <div class="sixe-list-content">
                                        提前发现健康影响的因素，减轻对用户健康的危害
                                    </div>
                                </div>
                                <div class="six-list">
                                    <div class="sixe-list-img">
                                        <img src="@/static/img/siximg4.png">
                                    </div>
                                    <div class="sixe-list-title">
                                        健康管理
                                    </div>
                                    <div class="sixe-list-content">
                                        通过远程专家专业指导+健康云监护的家庭全科医生健康管理服务
                                    </div>
                                </div>
                                <div class="six-list">
                                    <div class="sixe-list-img">
                                        <img src="@/static/img/siximg5.png">
                                    </div>
                                    <div class="sixe-list-title">
                                        健康监测
                                    </div>
                                    <div class="sixe-list-content">
                                        通过健康云监护平台协助卫生部门达到加强慢性病预防工作
                                    </div>
                                </div>
                                <div class="six-list">
                                    <div class="sixe-list-img">
                                        <img src="@/static/img/siximg6.png">
                                    </div>
                                    <div class="sixe-list-title">
                                        居家养老
                                    </div>
                                    <div class="sixe-list-content">
                                        缓解老百姓“看病难看病贵”的问题，实现居家养老甚至全民健康的国家长远规划
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="body-old">
                            <div :class="activeMenu == '智慧养老' ? 'old-title fadeinTAnimation' : 'old-title'"></div>
                            <div class="old-content">
                                <div :class="activeMenu == '智慧养老' ? 'old-content-data fadeinLAnimation' : 'old-content-data'">
                                    <div class="old-content-data-title">艾米奈华智慧养老管理服务后台</div>
                                    <div class="old-content-data-message">
                                        智慧养老管理服务平台是面向居家老人、
                                        社区及养老机构的传感网系统与信息平台，
                                        有别于传统养老系统，艾米养老系统是通过信息化、
                                        物联网技术和艾米医疗体系的互联互通，
                                        实现互联网+医养结合模式。平台以社区为依托，
                                        老龄人群为服务对象，企事业服务机构、医疗、养老机构为支撑，
                                        提供康复医疗和生活照料相结合的新型养老服务模式，
                                        既包括养老机构传统的生活护理服务、精神心理服务、老年文化服务，
                                        也融合了医疗康复服务。并在此基础上提供实时、快捷、高效、低成本的，
                                        物联化、互联化、智能化的养老服务。
                                    </div>
                                </div>
                                <div :class="activeMenu == '智慧养老' ? 'old-content-bg flipinYAnimation' : 'old-content-bg'"></div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="body-doctor">
                            <div :class="activeMenu == '爱家医生' ? 'doctor-title fadeinTAnimation' : 'doctor-title'"></div>
                            <div :class="activeMenu == '爱家医生' ? 'doctor-img flipinYAnimation' : 'doctor-img'">
                                <img src="@/static/img/qida.png">
                            </div>
                            <div :class="activeMenu == '爱家医生' ? 'doctor-data fadeinRAnimation' : 'doctor-data'">
                                <div class="doctor-data-title">互联网+医养结合</div>
                                <div class="doctor-item-title">让更多用户从中获益</div>
                                <div class="doctor-item-content">
                                    中润天骐以居家养老健康云监护平台为核心,与东北地区医
                                    疗机构合作,让居家养老健康云监护平台落实到更多有需求
                                    的地方,推动互联网+医养结合本土化老发展，让更多用户
                                    从中获益。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="body-we">
                            <div class="we-data">
                                <div :class="activeMenu == '联系我们' ? 'we-data-img fadeinLAnimation' : 'we-data-img'">
                                    <img src="@/static/img/we.png">
                                </div>
                                <div :class="activeMenu == '联系我们' ? 'we-data-item fadeinRAnimation' : 'we-data-item'">
                                    <div class="we-data-title">
                                        市场商务合作
                                    </div>
                                    <div class="we-data-message">
                                        <p>电话：0454-8306018</p>
                                    </div>
                                </div>
                            </div>
                            <div class="we-content">
                                <div class="we-list">
                                    <div class="we-item">
                                        <img :class="activeMenu == '联系我们' ? 'we-logo flipinYAnimation' : 'we-logo'" src="@/static/img/logo2.png">
                                        <div :class="activeMenu == '联系我们' ? 'we-txt fadeinLAnimation' : 'we-txt'">
                                            <p>联系方式：全国免费服务热线：400-625-3330</p>
                                            <p>全国免费售后电话：400-881-8508</p>
                                        </div>
                                    </div>
                                    <div class="we-gang">
                                        <img :class="activeMenu == '联系我们' ? 'flipinYAnimation' : ''" src="@/static/img/gang.png">
                                    </div>
                                    <div :class="activeMenu == '联系我们' ? 'we-item fadeinBAnimation' : 'we-item'">
                                        <div class="we-txt2">
                                            <p>总部地址: 北京市海淀区四季青路8号</p>
                                            <p>郦城工作区312室</p>
                                            <p>总部电话: 010-53340073</p>
                                            <p>分部地址: 黑龙江省佳木斯市前进区</p>
                                            <p>滨江东路389号</p>
                                            <p>分部电话: 0454-8306018</p>
                                        </div>
                                    </div>
                                    <div class="we-gang">
                                        <img :class="activeMenu == '联系我们' ? 'flipinYAnimation' : ''" src="@/static/img/gang.png">
                                    </div>
                                    <div class="we-item">
                                        <img :class="activeMenu == '联系我们' ? 'we-ewm flipinYAnimation' : 'we-ewm'" src="@/static/img/ewm.png">
                                    </div>
                                    <div :class="activeMenu == '联系我们' ? 'we-copy fadeinBAnimation' : 'we-copy'">
                                        ©版权所有 @ www.maximazrtq.com All Right Reserved .
                                        <a style="font-size:10px;color:#fff;text-decoration:none" href="https://beian.miit.gov.cn">黑ICP备2020006633号-1</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
export default {
    data() {
        return{
            menuSwiper: "",
            activeMenu: "网站首页",
            menuItem: ["网站首页","关于我们","六大优势","智慧养老","爱家医生","联系我们"],
        }
    },
    methods: {
        renderMenuSwiper() {
            this.menuSwiper = new Swiper(".swiper-container", {
                // 垂直切换选项
                direction: "vertical",
                // 开启滑轮
                mousewheel: true,
                // 开启开启键盘控制翻页
                keyboard: true,
                // 如果需要分页器
                pagination: {
                    el: ".swiper-pagination",
                },
                on: {
                    slideChange: ()=>{
                        this.activeMenu = this.menuItem[this.menuSwiper.activeIndex];
                    }
                },
            });
        },
        handleMenu(activeMenu, key) {
            this.activeMenu = activeMenu;
            this.menuSwiper.slideTo(key, 1000, false);
        },
    },
    mounted() {
        this.renderMenuSwiper();
    },
}
</script>

<style scoped>
    @import url("../../static/css/index.css");
    /* @import url("../../static/css/animation.css"); */
</style>



// WEBPACK FOOTER //
// src/view/home/Home.vue


// WEBPACK FOOTER //
// src/views/home/Home.vue